import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { breakpoint } from '../theme/breakpoint';
import { buttonStyles, buttonReset } from '../styled/buttons';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  background: ${({ theme, $greyBackground }) =>
    $greyBackground ? theme.palette.lightBackground : null};
  padding: ${({ theme, $greyBackground }) =>
    $greyBackground ? theme.spacing.standard : null};
  padding-bottom: 0;

  ${breakpoint.tablet`
    flex-direction: row;
    justify-content: flex-start;
  `}
`;

export const Inner = styled.div`
  display: flex;
  width: 100%;
`;

export const ShareLink = styled.a`
  ${buttonReset};
  ${buttonStyles};
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  margin-right: ${({ theme }) => theme.spacing.standard};
`;

export const StyledSVG = styled(SVG)`
  display: block;
  margin-right: ${({ theme }) => theme.spacing.small};
  fill: ${({ theme }) => theme.palette.link};
  width: 1em;
  height: 1em;
`;
